import axios from "axios";
import { resolveApiUrl } from "../../assets/GlobalVariables";
import { getSessionId } from "../../services/authService";
import { getUserInfo } from "../../services/localStorage";
import { formatHrBookingRef } from "../../utils/bookingRefDisplay.js";
import { normalizeSearchToken } from "./operationRequestSearchMatch.js";

/**
 * Fallback: הזמנה לפי booking_references כשאינה ב-bundle (טווח תאריכים / סינון).
 * @param {string} rawQuery
 * @returns {Promise<object|null>}
 */
export async function fetchOperationRequestOrderByBookingRef(rawQuery) {
  const needle = normalizeSearchToken(rawQuery);
  if (!needle || needle.length < 6 || !/^\d+$/.test(needle)) {
    return null;
  }

  const sessionID = await getSessionId();
  if (!sessionID) return null;

  const sid = String(sessionID).trim();
  const userInfo = getUserInfo();
  const agentId = userInfo?.id != null ? String(userInfo.id).trim() : "";

  try {
    const url = resolveApiUrl(`/api/bookings/by-ref/${encodeURIComponent(needle)}`);
    console.log("[OP_REQUEST_SEARCH_API_PAYLOAD]", {
      endpoint: url,
      method: "GET",
      payload: { bookingRef: needle, op_request_search: true },
    });

    const { data } = await axios.get(url, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${sid}`,
        "X-Session-ID": sid,
      },
      withCredentials: true,
      timeout: 20000,
    });

    if (!data?.success || !data.entity_id) {
      console.log("[OP_REQUEST_SEARCH_BOOKING_REF_FALLBACK]", {
        needle,
        found: false,
        reason: data?.error || "not_found",
      });
      return null;
    }

    const refAgent = data.agent_id != null ? String(data.agent_id).trim() : "";
    if (agentId && refAgent && refAgent !== agentId) {
      console.log("[OP_REQUEST_SEARCH_BOOKING_REF_FALLBACK]", {
        needle,
        found: true,
        denied: true,
        reason: "agent_mismatch",
      });
      return null;
    }

    const entityId = String(data.entity_id).trim();
    const bookingRef = data.booking_ref != null ? String(data.booking_ref).trim() : needle;
    const display =
      data.booking_ref_display ||
      formatHrBookingRef(bookingRef) ||
      (bookingRef ? `HR-${bookingRef}` : null);

    const et = String(data.entity_type || data.source_table || "").toLowerCase();
    let category = "packages";
    let rawOrderType = "lds_package";
    if (et.includes("hotel") || et === "gimmonix") {
      category = "hotels";
      rawOrderType = "hotel";
    } else if (et.includes("dynamic")) {
      category = "dynamic-packages";
      rawOrderType = "dynamic_package";
    } else if (et.includes("cruise")) {
      category = "cruise";
      rawOrderType = "cruise";
    } else if (et.includes("flight") && !et.includes("hotel")) {
      category = "טיסות";
      rawOrderType = "flight";
    }

    const picker = {
      key: `booking-ref-${rawOrderType}-${entityId}`,
      id: entityId,
      orderId: entityId,
      displayOrderNumber: display,
      bookingRef,
      mainContact: data.customer_name ? String(data.customer_name).trim() : "",
      hotelName: "—",
      checkIn: "",
      checkOut: "",
      status: "—",
      category,
      rawOrderType,
      raw: {
        booking_ref: bookingRef,
        entity_type: data.entity_type,
        source_table: data.source_table,
        _fromBookingRefLookup: true,
      },
    };

    console.log("[OP_REQUEST_SEARCH_BOOKING_REF_FALLBACK]", {
      needle,
      found: true,
      entityId,
      displayOrderNumber: display,
      category,
    });

    return picker;
  } catch (e) {
    console.warn("[OP_REQUEST_SEARCH_BOOKING_REF_FALLBACK]", {
      needle,
      error: String(e?.message || e),
      status: e?.response?.status,
    });
    return null;
  }
}
